// Environment variables for production deployment
export const IsLocal = process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENV === 'local';
export const IsProd = process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENV === 'prod';

// API URL selection with environment variables
export const API_BASE_URL = "https://api.sierahr.com/api/"; // Hardcoded for local testing

// Additional API configurations
export const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000;
export const API_RETRY_ATTEMPTS = parseInt(process.env.REACT_APP_API_RETRY_ATTEMPTS) || 3;
export const API_RETRY_DELAY = parseInt(process.env.REACT_APP_API_RETRY_DELAY) || 1000;
